import React, { useCallback, useState } from 'react';
import { Button, Col, Form, Row, Table } from 'reactstrap';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { buttonStyle } from '../../../../../../components/Containers/ConfigurationContainer/components/utils';
import ReactLoader from '../../../../../../components/Loader';

import { useGetAllMatrixSLAHolidays } from '../../../../hooks/useGetAllMatrixSLAHolidays';
import MatrixSLAHolidaysModal from './MatrixSLAHolidaysModal';
import ModalConfirmation from '../../../../../../components/Modal/ConfirmationModal';
import {
  convertToBrazilianDateFormat,
  convertToShortTimeFormat
} from '../../../../utils';

import MatrixSLAHolidaysService from '../services';

const columns = [
  'Nome',
  'Descrição',
  'Data',
  'Hora de Inicio',
  'Hora de Fim',
  'Ações'
];

const HolidaysTable = ({ matrixSLAId }) => {
  const systemConfiguration = useSelector((state) => state.systemConfiguration);

  const [modal, setModal] = useState(false);
  const [openModalConfirmation, setOpenModalConfirmation] = useState(false);
  const [currentHoliday, setCurrentHoliday] = useState(null);
  const { matrixSLAHolidays, fetchMatrixSLAHolidays, loadingHolidays } =
    useGetAllMatrixSLAHolidays(matrixSLAId);

  const toggle = useCallback(() => {
    setModal((prevModal) => !prevModal);
  }, []);

  const handleDeleteHoliday = useCallback(
    async (id) => {
      const usrLogin = localStorage.getItem('login');
      MatrixSLAHolidaysService.deleteMatrixSLAHolidays(id, usrLogin)
        .then((response) => {
          toast.success(
            response.data.message || 'Feriado excluído com sucesso!'
          );
          fetchMatrixSLAHolidays();
          setOpenModalConfirmation(false);
        })
        .catch((error) => {
          console.log(error);
          toast.error(
            error.response?.data?.message ||
              error.message ||
              'Erro ao excluir feriado!'
          );
        });
    },
    [fetchMatrixSLAHolidays]
  );

  const editHoliday = useCallback(
    (holiday) => {
      setCurrentHoliday(holiday);
      toggle();
    },
    [toggle]
  );

  return (
    <>
      {loadingHolidays ? (
        <Row className="justify-content-md-center">
          <ReactLoader />
        </Row>
      ) : (
        <>
          <Form
            className="needs-validation"
            onSubmit={(e) => e.preventDefault()}
          >
            <div
              style={{
                overflowX: 'auto'
              }}
            >
              <Table>
                <thead>
                  <tr>
                    {columns.map((column) => (
                      <th key={column}>{column}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {matrixSLAHolidays.map((holiday) => (
                    <tr key={holiday.id}>
                      <td>{holiday.name}</td>
                      <td>{holiday.description}</td>
                      <td>{convertToBrazilianDateFormat(holiday.date)}</td>
                      <td>{convertToShortTimeFormat(holiday.start_hour)}</td>
                      <td>{convertToShortTimeFormat(holiday.end_hour)}</td>
                      <td>
                        <Button
                          size="sm"
                          color="info"
                          onClick={(event) => {
                            event.preventDefault();
                            editHoliday(holiday);
                          }}
                        >
                          <li className="fas fa-edit"></li>
                        </Button>
                        <Button
                          size="sm"
                          color="danger"
                          onClick={(event) => {
                            event.preventDefault();
                            setOpenModalConfirmation(true);
                            setCurrentHoliday(holiday);
                          }}
                        >
                          <li className="fas fa-trash"></li>
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
            <Row
              className="mb-3"
              style={{
                display: 'flex'
              }}
            >
              <Col
                style={{
                  display: 'flex',
                  justifyContent: 'flex-start'
                }}
              >
                <Button
                  className="tour7-dt_matrix_sla_holidays_add_holiday"
                  style={buttonStyle(systemConfiguration.primary_color)}
                  size="sm"
                  onClick={() => {
                    setCurrentHoliday(null);
                    toggle();
                  }}
                >
                  Adicionar
                </Button>
              </Col>
            </Row>
          </Form>
          {matrixSLAId && (
            <>
              <MatrixSLAHolidaysModal
                modal={modal}
                toggle={toggle}
                matrixSLAId={matrixSLAId}
                fetchMatrixSLAHolidays={fetchMatrixSLAHolidays}
                currentHoliday={currentHoliday}
                setCurrentHoliday={setCurrentHoliday}
              />
              <ModalConfirmation
                isModalOpen={openModalConfirmation}
                onModalToggle={setOpenModalConfirmation}
                unmountOnClose={true}
                idResource={currentHoliday?.id}
                deleteResource={handleDeleteHoliday}
                message={'Tem certeza que deseja excluir esse feriado?'}
              />
            </>
          )}
        </>
      )}
    </>
  );
};

export default HolidaysTable;
